module.exports = __webpack_public_path__ + "static/media/camera.465c190c.svg";